import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/ViewSubmission/desktop';
import Mobile from 'pages/ViewSubmission/mobile';
import { PageContext } from 'pages/ViewSubmission/PageProvider';
import Tablet from 'pages/ViewSubmission/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading } = useApp();
    const { device } = useViewport();

    const props = useContext(PageContext);

    const { currentAssignment, currentSubmission } = props;

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isLoading || !currentAssignment || !currentSubmission ? <Loading /> : <>{renderResponsiveLayout(device)}</>;
};

export default PageLayout;
